import { render, staticRenderFns } from "./AdminRelatedServicesModal.vue?vue&type=template&id=2d6bb5da"
import script from "./AdminRelatedServicesModal.vue?vue&type=script&lang=js"
export * from "./AdminRelatedServicesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports